import { render, staticRenderFns } from "./CierresLayout.vue?vue&type=template&id=36612801"
import script from "./CierresLayout.vue?vue&type=script&lang=ts"
export * from "./CierresLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports